export default __webpack_public_path__ + "static/media/beQI.49aa862e.png";